import { styled } from '@linaria/react';
import { Button } from '@vio/atlas/Button';
export const MOBILE_HEADER_HEIGHT = 65;
export const HeaderElement = /*#__PURE__*/styled('header')({
  name: "HeaderElement",
  class: "hlk4z8d",
  propsAsIs: false
});
export const HeaderTopContentElement = /*#__PURE__*/styled('div')({
  name: "HeaderTopContentElement",
  class: "hdullu7",
  propsAsIs: false
});
export const logoStyles = "lfm2kea";
const _exp14 = /*#__PURE__*/() => Button;
export const BackButtonElement = /*#__PURE__*/styled(_exp14())({
  name: "BackButtonElement",
  class: "b92hxar",
  propsAsIs: true
});
export const Spacer = /*#__PURE__*/styled('div')({
  name: "Spacer",
  class: "s184ci7",
  propsAsIs: false
});
export const EndContentWrapper = /*#__PURE__*/styled('div')({
  name: "EndContentWrapper",
  class: "e1pndj56",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");